/**
 * Environment configuration.
 *
 * Reads URLs from Vite build-time environment variables (`import.meta.env`).
 * Falls back to production defaults when variables are missing.
 *
 * The `bffApiUrl` value does NOT include the `/hanko-menu` path segment —
 * that is appended by the API client when constructing the request URL.
 */

import type { EnvironmentConfig } from '@/types';

export function resolveEnv(): EnvironmentConfig {
  const appTarget = import.meta.env.VITE_APP_TARGET ?? 'hanko-menu';
  const loginApiUrl = import.meta.env.VITE_LOGIN_API_URL ?? '';
  const bffApiUrl = import.meta.env.VITE_BFF_API_URL || 'https://api.prod.vdp.vaisala.com';
  const registerApiUrl = import.meta.env.VITE_REGISTER_URL ?? '';
  const accountApiUrl = import.meta.env.VITE_ACCOUNT_URL ?? '';
  const cartUrl = import.meta.env.VITE_CART_URL ?? '';
  const rawPollEnv = import.meta.env.VITE_POLL_INTERVAL_MS;
  const rawPollInterval = rawPollEnv ? Number(rawPollEnv) : NaN;
  const pollIntervalMs =
    Number.isFinite(rawPollInterval) && rawPollInterval >= 0 ? rawPollInterval : 10_000;

  return {
    accountApiUrl,
    appTarget,
    bffApiUrl,
    cartUrl,
    loginApiUrl,
    pollIntervalMs,
    registerApiUrl,
    signInUrl: `${loginApiUrl}/auth/login/${appTarget}`,
  };
}
